import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import Button from '@mui/material/Button';
import { useCallback, useState } from 'react';
import { LoginRecoveryModal } from './loginRecoveryModal';
export const ForgottenLoginControl = () => {
    const [isOpen, setIsOpen] = useState(false);
    const onClickModalOpen = useCallback(() => {
        setIsOpen(true);
    }, []);
    return (_jsxs(_Fragment, { children: [_jsx("div", { css: css `
          margin-top: 15px;
          align-self: center;
        `, children: _jsx(Button, { onClick: onClickModalOpen, size: 'small', variant: 'contained', children: "Forgotten Login?" }) }), isOpen && _jsx(LoginRecoveryModal, { onClose: () => setIsOpen(false) })] }));
};
